/**
 * Recherche FAQ (template-parts/faq-hero.php) : [data-faq-search] avec data-message.
 * Requête admin-ajax `search_faqs` (nonce UNYC.ajax.faq_search) dès 4 caractères ; le serveur
 * renvoie json_encode($html), c'est-à-dire une chaîne HTML (<ul class="result">…</ul>).
 * Remplace le composant Vue FaqSearch (axios → fetch + AbortController).
 */
UNYC.register('faq-search', () => {
    UNYC.init('[data-faq-search]', 'faq-search', (root) => {
        const form = root.querySelector('.search-form');
        const field = root.querySelector('.search-field');
        const results = root.querySelector('.search-results');
        const result = root.querySelector('.result');
        const message = root.querySelector('.message');
        const messageText = message ? message.querySelector('p') : null;
        const emptyMessage = root.dataset.message || '';

        if (!(form && field && results && result && message && messageText)) return;

        const state = { result: '', message: '' };
        let controller = null;
        let timer = 0;

        const render = () => {
            result.innerHTML = state.result;
            result.style.display = state.result ? '' : 'none';
            messageText.textContent = state.message;
            message.style.display = state.message ? '' : 'none';
            results.classList.toggle('show', Boolean(state.result || state.message));
        };

        const search = async () => {
            const term = field.value;

            if (term.length <= 3) return;

            form.classList.add('loading');
            state.message = '';
            render();

            const body = new FormData();
            body.append('faq_search', UNYC.ajax.faq_search || '');
            body.append('action', 'search_faqs');
            body.append('term', term);

            if (controller) controller.abort();
            controller = new AbortController();

            try {
                const response = await fetch(UNYC.ajax.url, {
                    method: 'POST',
                    body,
                    credentials: 'same-origin',
                    signal: controller.signal,
                });

                if (!response.ok) throw new Error(`HTTP ${response.status}`);

                const html = await response.json();

                if (typeof html !== 'string') throw new Error('Incorrect response data');

                const parsed = new DOMParser().parseFromString(html, 'text/html');

                form.classList.remove('loading');

                if (parsed.querySelectorAll('li').length) {
                    state.result = html;
                } else {
                    state.result = '';
                    state.message = emptyMessage;
                }

                render();
            } catch (error) {
                if (error.name === 'AbortError') return;

                console.error(error.message);
                form.classList.remove('loading');
                state.message = emptyMessage;
                render();
            }
        };

        field.addEventListener('input', () => {
            window.clearTimeout(timer);
            timer = window.setTimeout(search, 150);
        });

        document.addEventListener('click', () => {
            if (state.result || state.message) {
                state.result = '';
                state.message = '';
                render();
            }
        });
    });
});
